/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

export const archiveTrackModelSchema = z.object({
    "isArchive": z.boolean().describe("Флаг архивности")
    })